import { useNavigate } from 'react-router-dom';
import { Building2, ArrowRight } from 'lucide-react';
import { usePendingOffsets } from '@/hooks/usePendingOffsets';

// iter948 — Dashboard alert card for pending cross-branch internal-offset
// approvals. Renders null when there's nothing to approve. Reuses the shared
// usePendingOffsets loader (same data as the sidebar / hub badge).
export default function PendingOffsetsAlertCard() {
  const navigate = useNavigate();
  const { count } = usePendingOffsets();
  if (!count) return null;
  return (
    <button
      type="button"
      onClick={() => navigate('/reconciliation-center')}
      data-testid="dashboard-pending-offsets-card"
      className="w-full flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-left transition-all hover:bg-amber-100/70 hover:shadow-[0_2px_12px_rgba(217,119,6,0.12)]"
    >
      <span className="w-9 h-9 rounded-lg bg-amber-100 border border-amber-300 flex items-center justify-center shrink-0">
        <Building2 size={18} className="text-amber-700" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-amber-900">
          {count} cross-branch approval{count === 1 ? '' : 's'} waiting
        </span>
        <span className="block text-[12px] text-amber-700/90">
          Bank auto-match found inter-branch payments — review &amp; create the internal offsets.
        </span>
      </span>
      <span className="shrink-0 inline-flex items-center gap-1 text-[12px] font-semibold text-amber-800">
        Review <ArrowRight size={14} />
      </span>
    </button>
  );
}
